export default "__VITE_ASSET__BgNeDiIr__"